/**
 * @file   专题页
 * @create macaiqi 2021/11/24
 * @update
 */
// import React, { useEffect, useRef, useState, useCallback } from 'react';
// import { Link, useLocation, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cls from 'classnames'
import { queryListQuick, queryValueList,queryCatList, querySameAttrInstanceQuick, querySameTagInstance } from '../../../shared/api'
import { GetQueryString } from '../../../../utils'
import Loading from '../../../components/Loading';
import Slider from '@ant-design/react-slick';
import usePage from '../../../components/Hooks/usePage';
import { Pager } from '@portal-site/pager';
import $ from 'jquery'
import './index.scss'
import SearchComponent from '../KnowledgeRetrieval/SearchComponent';
import { useHistory } from 'react-router';
// 第一部分
const Top = () => {
  return (
    <div className="top">
      <SearchComponent />
    </div>
  )
}
// 内容导航
const InnerNav = ({ pathname, setType, setConceptCodes, setNodeName, setInstanceNames, setList1 }) => {
  const history = useHistory()
  const innernav = [
    {
      name: '建筑艺术',
      channel: 'AncientConstruct',
      type: '01',
      conceptCode: ['Technique','Tool','Material','ThoughtAndTheory','Term']
    },
    {
      name: '精品文物',
      channel: 'CulturalRelic',
      type: '02',
      conceptCode: ['CulturalRelic']
    },
    {
      name: '历代名人',
      channel: 'Person',
      type: '03',
      conceptCode: ['Person']
    },
    {
      name: '历史事件与典故轶事',
      channel: 'History',
      type: '04',
      conceptCode: ["HistoricalEvent", "AllusionAndAnecdote"]
    },
    {
      name: '相关作品',
      channel: 'Works',
      type: '05',
      conceptCode: ["Work"]
    },
    {
      name: '其他',
      channel: 'Other',
      type: '06',
      conceptCode: ["NormAndRule", "Organization", "GeographicalCulture","AcademicAchievement"]
    }
  ]
  useEffect(() => {
    if (pathname.includes('AncientConstruct')) {
      setType('01')
      setConceptCodes(innernav[0].conceptCode)
    } else if (pathname.includes('Person')) {
      setType('03')
      setConceptCodes(innernav[2].conceptCode)
    } else if (pathname.includes('CulturalRelic')) {
      setType('02')
      setConceptCodes(innernav[1].conceptCode)
    } else if (pathname.includes('History')) {
      setType('04')
      setConceptCodes(innernav[3].conceptCode)
    } else if (pathname.includes('Works')) {
      setType('05')
      setConceptCodes(innernav[4].conceptCode)
    } else if (pathname.includes('Other')) {
      setType('06')
      setConceptCodes(innernav[5].conceptCode)
    }
    // 如果跳进时传了参数，则直接显示那一栏
    if (GetQueryString('conceptCode')) {
      setConceptCodes([GetQueryString('conceptCode')])
    }
    if (GetQueryString('nodeName')) {
      setNodeName(GetQueryString('nodeName'))
    }
    if (GetQueryString('instanceName')) {
      setInstanceNames([GetQueryString('instanceName')])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className="innernav">
      <div className="allcenter">
        {innernav.map((item, index) => {
          return (
            <div className={cls("item", { 'active': pathname?.includes(item.channel) })} key={index} onClick={() => {
              // 跳转之前清一下之前的
              // setInstanceNames(['all'])

              history.push(`/Subject/${item.channel}`)
              setType(item.type)
              setConceptCodes(item.conceptCode)
              setList1(false)

            }}>
              {item.name}
            </div>
          )
        })}
        <Link to='/Refenrences' className="ckwx" target='_blank'>
          参考文献
        </Link>
      </div>

    </div >
  )
}

// 首页
const Subject = () => {
  const { pathname } = useLocation()
  const [loading, setloading] = useState(true)
  const [data, setData] = useState()
  const [navdata, setNavdata] = useState() // 分类选项
  const [leftnav, setLeftnav] = useState() // 左边分类选项
  // const [current, setCurrent] = useState(1) // 当前页
  const [conceptCodes, setConceptCodes] = useState([]) // 概念代码
  const [instanceNames, setInstanceNames] = useState(['all']) // 选择传
  const [nodeName, setNodeName] = useState() // 历史名人选择时
  const [type, setType] = useState() // 01 历史建筑群
  const [list1, setList1] = useState(((GetQueryString('conceptCode') === 'Writing') || GetQueryString('conceptCode') === 'Person') && pathname.includes('AncientConstruct') ? true : false) // 古建营造- 著作 人物选择时另外调用接口
  // const [pagename, setPagename] = useState() // 标题
  const [navpadding, setnavpadding] = useState()
  const [initPage, setPage] = usePage(1);
  useEffect(() => {
    // 建筑艺术、精品文物要左边选项
    if (pathname.includes('AncientConstruct') || pathname.includes('CulturalRelic')) {
      let conceptCodes1 = [];
      if(conceptCodes.indexOf('AncientConstrut')>-1){
        conceptCodes1 = ['Technique','Tool','Material','ThoughtAndTheory','Term']
      }else{
        conceptCodes1 = JSON.parse(JSON.stringify(conceptCodes))
      }
      // const conceptCodes1 = pathname.includes('AncientConstruct') ? ['Technique','Tool','Material','ThoughtAndTheory','Term'] : ['CulturalRelic'];
      const attrNames = ['民居','祠堂','牌坊','砖雕','石雕','木雕'];
      if(conceptCodes1.length>0){
        queryCatList({conceptCodes:conceptCodes1,attrNames:attrNames}).then(res => {
          const keys = Object.keys(res);
          let data = [];
          let sdTotal = 0;
          keys.forEach((n) => {
            if(n != '砖雕' && n != '石雕' && n != '木雕'){
              data.push({
                name: n,
                count: res[n]
              });
            }else{
              sdTotal += res[n];
            }
          });
          data.push({
            name:'三雕',
            count: sdTotal
          })
          setLeftnav(data);
        })
      }
      // setInstanceNames(['all']);
    }else{
      setLeftnav([]);
      // setInstanceNames([]);
    }

  }, [pathname,conceptCodes])
  useEffect(() => {
    if (type) {
      // 每个大类下的横向筛选项配置，如：人物所属朝代
      queryValueList(type).then(res => {
        setNavdata(res)
      })
    }
  }, [type])
  
  useEffect(() => {
    pageChange(1);
  }, [conceptCodes, instanceNames, nodeName, pathname, list1])

  const pageChange = (page) => {
    setPage(page);
    listDataQuery(page);
  }

  const listDataQuery = (page) => {
    if (conceptCodes) {
      // 建筑艺术、精品文物实例列表查询
      if (!list1) {
        if (pathname.includes('Person')) {
          // querySameAttrInstanceQuick({
          //   attrEnglishCodes: ["dynasty"],
          //   conceptCodes: conceptCodes,
          //   current: page,
          //   dictCode: '',
          //   nodeName: nodeName,
          //   size: 48
          // }).then(res => {
          //   setData(res)
          //   setloading(false)
          // })
          queryListQuick({
            conceptCodes: ['Person'], // 概念代码
            current: page,
            instanceNames: nodeName ? (nodeName == '宋朝' ? ['南宋','北宋'] : [nodeName]) : [], 
            size: 48
          }).then(res => {
            setData(res)
            setloading(false)
          })
        } else {
          // 建筑艺术不要左侧筛选
          // let attrs = pathname.includes('AncientConstruct') || pathname.includes('CulturalRelic') ? JSON.parse(JSON.stringify(instanceNames)) : [];
          let attrs = pathname.includes('CulturalRelic') ? JSON.parse(JSON.stringify(instanceNames)) : [];
          // if(conceptCodes.indexOf('Sculpture')>-1){
            
          // }
          let index = attrs.indexOf('三雕');
          if(index>-1){
            attrs.splice(index,1);
            attrs.push('砖雕','石雕','木雕');
          }
          queryListQuick({
            conceptCodes: conceptCodes, // 概念代码
            current: page,
            instanceNames: attrs.indexOf('all')>-1 ? [] : attrs, 
            relationshipNames:attrs.indexOf('all')>-1 ? null : ["subject"],
            size: 48
          }).then(res => {
            setData(res)
            setloading(false)
          })
        }
      } 
      // 历史名人、历史事件、典故轶事、作品实例列表查询
      else{
        querySameTagInstance({
          conceptCodes: conceptCodes, // 概念代码
          current: page,
          size: 48
        }).then(res => {
          setData(res)
          setloading(false)
        })
      }
    }
  }

  function Arrow(props) {
    const { iconcls, className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      >
        <i className={cls(iconcls)} />
      </div>
    );
  }
  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 3,
    variableWidth: true,
    draggable: false,
    prevArrow: <Arrow iconcls={navpadding ? 'prev' : ''} />,
    nextArrow: <Arrow iconcls='next' />,
    afterChange: current => {
      if (current > 0) {
        setnavpadding(true)
      } else {
        setnavpadding(false)

      }
      if (current > 1) {
        // 点一次后右箭头就隐藏
        setTimeout(() => {
          $('.slick-next').hide()
        }, 200);
      } else {
        $('.slick-next').show()
      }
      // // 最後一个到左边距离小于整个宽度的时候就不显示向后箭头
      // if ($('.choose1 span')?.eq(navdata?.length)?.offset()?.left - $('.scroll')?.offset()?.left + $('.choose1 span')?.eq(navdata?.length)?.width() <= $('.scroll')?.width()) {
      //   $('.slick-next').hide()
      // } else {
      //   $('.slick-next').show()

      // }
    }
  };
  return (<div className="subject-page">
    <Top />
    <InnerNav pathname={pathname} setList1={setList1} setType={setType} setConceptCodes={setConceptCodes} setNodeName={setNodeName} setInstanceNames={setInstanceNames} />

    <div className="allcenter">
      <div className="content">
        {
          // 建筑艺术不展示左侧筛选项
          // (pathname.includes('AncientConstruct') || pathname.includes('CulturalRelic')) &&
          (pathname.includes('CulturalRelic')) &&
          <div className={cls("l-nav")}>
            <div className={cls("select", { 'active': instanceNames.indexOf('all')>-1 })} onClick={() => { 
              setloading(true)
              setPage(1)
              setInstanceNames(['all']) 
            }}>
              全部
            </div>
            {leftnav?.map((item, index) => {
              return (
                <div className={cls("select", { 'active': instanceNames.indexOf(item.name)>-1 })} key={index} onClick={() => {
                  setloading(true)
                  setPage(1)
                  setInstanceNames([item.name])
                }}>
                  {item.name}（{item.count}）
                </div>
              )
            })}
          </div>
        }
        <div className="main">
          <div className={cls("scroll", { navpadding })}>
            {navdata?.length > 0 && <div className="choose1">
              {pathname.includes('AncientConstruct') ?
                <>
                  <span className={cls({ 'active': conceptCodes?.length === 5 })} onClick={() => {
                    setloading(true)
                    setPage(1)
                    setConceptCodes(['Technique','Tool','Material','ThoughtAndTheory','Term'])
                  }}>全部</span>
                  {navdata?.map((item, index) => {
                    return (
                      <span key={index} className={item.conceptCode && conceptCodes?.length === 1 && conceptCodes?.includes(item?.conceptCode) ? 'active' : ''} onClick={() => {

                        if (item.conceptCode === 'Writing' || item.conceptCode === 'Person') {
                          setList1(true)
                        } else {
                          setList1(false)

                        }
                        setPage(1)
                        setloading(true)
                        setConceptCodes([`${item.conceptCode}`])

                      }}>{item.name}</span>
                    )
                  })}
                </> : pathname.includes('CulturalRelic') ?
                  <Slider {...settings}>
                    <div className={cls('item-c', { 'active': conceptCodes?.includes('CulturalRelic') })} onClick={() => {
                      setPage(1)
                      setloading(true)
                      setConceptCodes(['CulturalRelic'])
                    }} ><span>全部</span></div>
                    {navdata?.map((item, index) => {
                      return (
                        <div key={index} className={cls('item-c', { 'active': conceptCodes?.includes(item?.conceptCode) })} onClick={() => {
                          setPage(1)
                          setloading(true)
                          setConceptCodes([`${item.conceptCode}`])
                        }}><span>{item.name}</span></div>
                      )
                    })}
                  </Slider>
                  :
                  pathname.includes('Person') ?
                    <>
                      <span className={cls({ 'active': !nodeName })} onClick={() => {
                        setPage(1)
                        setloading(true)
                        setNodeName(null)
                      }}>全部</span>
                      {navdata?.map((item, index) => {
                        return (
                          <span key={index} className={cls({ 'active': nodeName === item.name })} onClick={() => {
                            setPage(1)
                            setloading(true)
                            setNodeName(item.name)
                          }}>{item.name}</span>
                        )
                      })}
                    </>
                    : pathname.includes('History') ? <>
                      <span className={cls({ 'active': conceptCodes?.length === 2 })} onClick={() => {
                        setPage(1)
                        setloading(true)
                        setConceptCodes(["HistoricalEvent", "AllusionAndAnecdote"])
                      }}>全部</span>
                      {navdata?.map((item, index) => {
                        return (
                          <span key={index} className={cls({ 'active': conceptCodes.includes(item.conceptCode) & conceptCodes.length === 1 })} onClick={() => {
                            setPage(1)
                            setloading(true)
                            setConceptCodes([`${item.conceptCode}`])
                          }}>{item.name}</span>
                        )
                      })}
                    </>
                    : pathname.includes('Works') ?
                      <>
                        <span className={cls({ 'active': conceptCodes?.includes('Work') })} onClick={() => {
                          setPage(1)
                          setloading(true)
                          setConceptCodes(["Work"])
                        }}>全部</span>
                        {navdata?.map((item, index) => {
                          return (
                            <span key={index} className={cls({ 'active': conceptCodes.includes(item.conceptCode) })} onClick={() => {
                              setPage(1)
                              setloading(true)
                              setConceptCodes([`${item.conceptCode}`])
                            }}>{item.name}</span>
                          )
                        })}
                      </>
                        :
                        <>
                          <span className={cls({ 'active': conceptCodes?.length === 4 })} onClick={() => {
                            setPage(1)
                            setloading(true)
                            setConceptCodes(["NormAndRule", "Organization", "GeographicalCulture","AcademicAchievement"])
                          }}>全部</span>
                          {navdata?.map((item, index) => {
                            return (
                              <span key={index} className={cls({ 'active': conceptCodes.includes(item.conceptCode) & conceptCodes.length === 1 })} onClick={() => {
                                setPage(1)
                                setloading(true)
                                setConceptCodes([`${item.conceptCode}`])
                              }}>{item.name}</span>
                            )
                          })}
                        </>
              }
            </div>}
          </div>

          {!loading ?
            <>
              <div className={cls("itembox", { small: pathname.includes('CulturalRelic') || pathname.includes('History') || pathname.includes('Works') })}>
                {data?.records?.map((item, index) => {
                  return (
                    <Link to={`/Subject/${pathname.split('/').reverse()[0]}/${item?.instanceId}`} key={index} target="_blank" >
                      <div className="scrolltext">
                        {item?.instanceName}
                      </div>
                    </Link>
                  )
                })}
              </div>
              {data?.records?.length === 0 && <div className='null'>
                <div className="img" />
                <div className="txt">抱歉暂无相关实例</div>
                <div className="txt1">您可以尝试减少筛选条件~</div>

              </div>}
              {data?.pages > 1 && (
                <Pager
                  containerClassName="mypager"
                  forcePage={initPage || 1}
                  pageCount={data?.pages}
                  total={data?.total}
                  onPageChange={(page) => pageChange(page)}
                  showLast={false}
                  showFirst={false}
                  prevLabel="<"
                  nextLabel=">"
                // showTotal
                />
              )}
            </>
            : <Loading />}

        </div>
      </div>

    </div>
  </div>)
};

export default Subject;
